/**
 * Pure helpers for linking a company outward. Kept apart from the glyphs in companyGlyphs.tsx
 * because a module that exports components must export only components for fast refresh to work —
 * the same split the contact surface already makes between contactFormat.ts and contactShared.tsx.
 */

/**
 * Enrichment-sourced URLs are untrusted input: anything with a non-http(s) scheme is dropped
 * (`javascript:` above all), a protocol-relative `//host` is given https, and a bare domain is
 * assumed to be https.
 */
export function toSafeUrl(url?: string | null): string | undefined {
  const trimmed = url?.trim()
  if (!trimmed) return undefined
  if (/^https?:\/\//i.test(trimmed)) return trimmed
  // `//example.com` is protocol-relative and legal in enrichment data; naively prefixing would
  // produce `https:////example.com`.
  if (trimmed.startsWith('//')) return `https:${trimmed}`
  if (/^[a-z][a-z0-9+.-]*:/i.test(trimmed)) return undefined
  return `https://${trimmed}`
}
